import classNames from 'classnames';
import React from 'react';

import { List, SectionTitle } from '@/ui/index';

import styles from './Milestones.module.scss';
import MilesstoneItem from '../../SvgComponents/MilestoneItem';

const Milestones = ({ data, className, isSmall }) => {
  const renderMilestonesListItem = (item, index) => {
    return <li key={index}>{item?.text}</li>;
  };
  const renderMilestonesCard = (item, index) => {
    return (
      <div className={styles['milestones-item-container']}>
        <article className={styles['milestones-item']} key={index}>
          <div className={styles['milestones-item_square']}>
            <div className={styles['milestones-item_square_small']}></div>
          </div>

          {!!item?.year && (
            <strong className={styles['milestones-item__year']}>
              {item.year}
            </strong>
          )}
          {!!item?.items && (
            <List className={styles['milestones-item__list']}>
              {item.items.map(renderMilestonesListItem)}
            </List>
          )}
        </article>

        <div className={styles['milestones-item-container_connector']}>
          <MilesstoneItem />
        </div>
      </div>
    );
  };

  return (
    <section className={classNames(styles.milestones, className)}>
      {!!data?.title && (
        <SectionTitle
          className={styles.milestones__title}
          titleModify={'title--large'}
        >
          {data.title}
        </SectionTitle>
      )}
      {!!data?.years && (
        <div
          className={classNames([
            styles.milestones__three,
            { [styles['milestones__three--narrowly']]: isSmall },
          ])}
        >
          <div className={styles.milestones__line}></div>
          {data.years.map(renderMilestonesCard)}
        </div>
      )}
    </section>
  );
};

export default Milestones;
